import React, { useState } from "react";

import { formatLocalDateTime } from "./format";
import { ContractVersionDTO } from "../../models/EnrollmentHistoryDTO";


export interface ContractHistoryProps {
	versions: ContractVersionDTO[] | undefined;
	onOpen: (version: ContractVersionDTO) => void;
}

/**
 * Historial del contrato de una matrícula (Esteban, 2026-09-26): cuándo y quién generó o subió cada
 * versión, para que se vea si toca generarlo de nuevo. Las reemplazadas quedan tachadas pero se abren igual.
 */
const ContractHistory: React.FC<ContractHistoryProps> = ({ versions, onOpen }) => {
	const [open, setOpen] = useState<boolean>(false);
	const list = versions || [];
	const vigentes = list.filter((v) => v.current);
	const generado = vigentes.find((v) => v.typeId === 1);
	const firmado = vigentes.find((v) => v.typeId === 2);
	const desechadas = list.length - vigentes.length;

	const linea = (texto: string, v: ContractVersionDTO) =>
		`${texto} el ${formatLocalDateTime(v.createdAt)}${v.createdBy ? " · " + v.createdBy : ""}`;

	return (
		<div style={{ fontSize: 13, color: "var(--wa-apagado)" }}>
			{generado ? <div>{linea("Generado", generado)}</div> : ""}
			{firmado ? <div>{linea("Firmado subido", firmado)}</div> : ""}
			{list.length > 1 ? (
				<button type="button" className="btn btn-link btn-sm" style={{ padding: 0, fontSize: 13 }} onClick={() => setOpen(!open)}>
					{open ? "Ocultar historial" : `Historial (${list.length} versiones${desechadas > 0 ? ", " + desechadas + " desechada" + (desechadas === 1 ? "" : "s") : ""})`}
				</button>
			) : ""}
			{open ? (
				<ul style={{ listStyle: "none", padding: 0, margin: "4px 0 2px", borderLeft: "2px solid var(--wa-filo)" }}>
					{list.map((v) => (
						<li key={"cv_" + v.id} style={{ display: "flex", gap: 10, alignItems: "flex-start", padding: "3px 0 3px 10px" }}>
							<div style={{ flex: 1, minWidth: 0 }}>
								<div style={{ textDecoration: v.current ? "none" : "line-through", color: v.current ? "var(--wa-tinta, inherit)" : "var(--wa-apagado)" }}>
									<b style={{ fontWeight: v.current ? 600 : 400 }}>{v.typeId === 2 ? "Firmado" : "Generado"}</b>
									{" · "}{formatLocalDateTime(v.createdAt)}{v.createdBy ? " · " + v.createdBy : ""}
								</div>
								<div style={{ fontSize: 12 }}>
									{v.current
										? <span style={{ color: "var(--wa-verde, #1B7F4A)", fontWeight: 600 }}>Vigente</span>
										: <span>{(v.discardReason || "Desechado") + (v.discardedAt ? " · " + formatLocalDateTime(v.discardedAt) : "") + (v.discardedBy ? " · " + v.discardedBy : "")}</span>}
								</div>
							</div>
							<button type="button" className="btn btn-link btn-sm" style={{ padding: 0, fontSize: 13, flexShrink: 0 }} onClick={() => onOpen(v)}>Ver</button>
						</li>
					))}
				</ul>
			) : ""}
		</div>
	);
};

export default ContractHistory;
